import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
    columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { RootState } from "src/redux/store";
type Props = {
    columns: columnTypes[];
    rows: any[];
    onAddNew: () => void;
    getActionOptions: any;
    paginationProps: {
        isTableLoading: boolean;
        totalItems: number;
        page: number;
        rowsPerPage: number;
        searchValue: string;
        setPage: (newPage: number) => void;
        setRowsPerPage: (newLimit: number) => void;
        setSearchValue: (newValue: string) => void;
    };
};

const GoalListing = ({
    columns,
    rows,
    onAddNew,
    paginationProps: {
        totalItems,
        isTableLoading,
        page,
        rowsPerPage,
        searchValue,
        setPage,
        setRowsPerPage,
        setSearchValue,
    },
}: Props) => {
    const navigate = useNavigate()
    const { userType } = useSelector((state: RootState) => state.auth);
    return (
      
            <>
                <div className="flex flex-col p-4">
                    {/* Page Header */}
                    <div className="p-4">
                        <ATMPageHeader
                            pageTitle="Goals"
                            searchValue={searchValue}
                            onSearchChange={setSearchValue}
                            buttonProps={{
                                btnName: "Add New",
                                onClick: onAddNew,
                            }}
                            hideAddButton={
                                !isCheckActionsPermission({
                                    moduleName: UserModuleNameTypes.GOAL,
                                    actionName: UserModuleActionTypes.ADD,
                                })
                            }
                        />
                    </div>

                    {/* Table */}
                    <div className="flex flex-col flex-1 overflow-auto">
                        <ATMTable
                            columns={columns}
                            rows={rows}
                            rowExtraClasses={() => "min-h-[40px]"}
                            onRowClick={(row: any) => {
                                if (userType === "ADMIN") {
                                    navigate(`/goals/goal/${row?._id}`)
                                } else {
                                    isCheckActionsPermission({
                                        moduleName: UserModuleNameTypes.GOAL,
                                        actionName: UserModuleActionTypes.VIEW,
                                    }) && navigate(`/goals/goal/${row?._id}`)
                                }
                            }
                            }
                            isLoading={isTableLoading}
                        />
                    </div>

                    <div className="flex justify-end p-4 py-2">
                        <ATMPagination
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={setPage}
                            onRowsPerPageChange={setRowsPerPage}
                            rowCount={totalItems}
                            rows={rows}
                        />
                    </div>
                </div>

            </>
    );
};

export default GoalListing;
